import styled from '@emotion/styled';
import { Dropdown, Text, tokens } from '@hotjar/hotsauce';
import { samplingWidgetButtonStyles } from '@hotjar/webapp/features/SamplingWidget/Widget';

export const TrafficIndicatorStyles = {
  StyledIndicatorContainer: styled.button`
    ${samplingWidgetButtonStyles}
    height: ${tokens.spacer.x4};
    text-decoration: underline;
    text-decoration-style: dotted;
    text-underline-position: under;
    cursor: pointer;
  `,
  StyledDropDown: styled(Dropdown)`
    .tippy-content {
      padding: 0;
    }
  `,
  Container: styled.div`
    display: flex;
    padding: ${tokens.spacer.x2};
  `,
  ContentWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `,
  Title: styled(Text)`
    display: flex;
    margin-top: 2px;
    margin-right: ${tokens.spacer.x0};
  `,
  IconContainer: styled.span`
    margin-right: ${tokens.spacer.x1};
    display: flex;
    align-items: center;
  `,
  Footer: styled.div`
    background-color: ${tokens.color.bg_info};
    display: flex;
    padding: ${tokens.spacer.x2};
    gap: ${tokens.spacer.x1};
  `,
  ContentDescription: styled.p`
    margin-bottom: ${tokens.spacer.x1pt5};
  `,
};
